import React from 'react';
import { observer } from 'mobx-react';
import { Button, TextField, Typography } from '@material-ui/core';
import { VariationScore } from 'components/VariationScore';
import { TextAsset } from '../../../../../../../types';
import useStyles from '../TextAssetItem.styles';
import { CreativeTemplatesEntities } from '../../../../../../../constants';

interface Props {
  textAsset: TextAsset;
  editedTextAsset: TextAsset;
  activeTabKey: CreativeTemplatesEntities;
  isShowingPostMaloneScore: boolean;
  isSaving: boolean;
  isCalculating: boolean;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSave: () => void;
  handleExitEditMode: () => void;
  maxLengthLabelAttrs: () => Record<string, unknown> | undefined;
}

export const TextAssetEditMode: React.FC<Props> = observer(
  ({
    textAsset,
    editedTextAsset,
    activeTabKey,
    isShowingPostMaloneScore,
    isCalculating,
    isSaving,
    handleInputChange,
    maxLengthLabelAttrs,
    handleSave,
    handleExitEditMode
  }: Props) => {
    const classes = useStyles(activeTabKey)();

    return (
      <div className={classes.Container}>
        <div className={classes.ListItemContainer}>
          {editedTextAsset.language && (
            <Typography variant="caption" className={classes.LanguageIndicator}>
              {editedTextAsset.language.toUpperCase()}
            </Typography>
          )}
          <TextField
            rows={3}
            rowsMax={20}
            className={classes.TextField}
            variant="outlined"
            defaultValue={textAsset.text}
            disabled={isSaving}
            onChange={handleInputChange}
            fullWidth
            multiline
            {...maxLengthLabelAttrs()}
          />
          {isShowingPostMaloneScore && (
            <div className={classes.VariationScoreContainer}>
              <VariationScore loading={isCalculating} score={editedTextAsset.postMaloneScore?.engagementScore || 0} />
            </div>
          )}
        </div>
        <div className="ButtonGroup">
          <Button className={classes.Button} color="primary" size="small" onClick={handleSave} disabled={isCalculating}>
            save
          </Button>
          <Button className={classes.Button} color="secondary" size="small" onClick={handleExitEditMode}>
            cancel
          </Button>
        </div>
      </div>
    );
  }
);
